module.exports = __webpack_public_path__ + "img/cloth_g1_shoe_06.7a8eb9e8.svg";